import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useTranslation } from 'react-i18next';
import { propertyData } from './data';
export const useSelectPropertyData = () => {
    const { t } = useTranslation();
    const data = propertyData.map((item) => {
        const translatedText = t(item.description);
        const parts = translatedText.split(',');
        return {
            ...item,
            description: parts.length > 1 ? (_jsxs(Box, { children: [_jsx(Box, { children: parts[0] }), _jsx(Box, { children: parts[1] })] })) : (translatedText),
        };
    });
    return { t, data };
};
